import * as MaisAtacado from "./MaisAtacado";
export default MaisAtacado;